var AppService = /** @class */ (function () {
    function AppService(api) {
        this.API = api;
    }
    AppService.prototype.createApp = function (name, organization, template, template_with_data, app_for_template, icon, global_style) {
        var url = '/apps';
        return this.API.post(url, {
            name: name,
            icon: icon,
            organization: organization,
            template_with_data: template_with_data,
            template: template,
            app_for_template: app_for_template,
            global_style: global_style,
        });
    };
    AppService.prototype.deleteApp = function (appId) {
        var url = "/apps/".concat(appId);
        return this.API.delete(url);
    };
    AppService.prototype.getAppPublishList = function (orgId) {
        var url = "/apps/publishlist?org=".concat(orgId);
        return this.API.get(url);
    };
    AppService.prototype.getAllOrgAppsList = function () {
        var url = '/apps/publishlist';
        return this.API.get(url);
    };
    AppService.prototype.getSearchedApps = function (searchString) {
        var url = "/search/?search=".concat(searchString);
        return this.API.get(url);
    };
    AppService.prototype.getApp = function (appId) {
        var url = "/apps/".concat(appId);
        return this.API.get(url);
    };
    AppService.prototype.getAppMeta = function (appId) {
        var url = "/apps/".concat(appId, "/meta");
        return this.API.get(url);
    };
    AppService.prototype.cloneApp = function (appId, req) {
        var url = "/apps/".concat(appId, "/clone");
        return this.API.post(url, req);
    };
    AppService.prototype.loadVersions = function (appId) {
        var url = "/versions/".concat(appId);
        return this.API.get(url);
    };
    AppService.prototype.createVersion = function (appId, version) {
        var url = "/versions/".concat(appId);
        return this.API.post(url, version);
    };
    AppService.prototype.loadChangeLog = function (appId) {
        var url = "/versions/".concat(appId, "/changes");
        return this.API.get(url);
    };
    AppService.prototype.fetchLatestVersionDetails = function (appId) {
        var url = "/versions/".concat(appId, "/latest");
        return this.API.get(url);
    };
    AppService.prototype.updateApp = function (app) {
        var url = "/apps/".concat(app.id);
        return this.API.patch(url, app);
    };
    AppService.prototype.updateAppVersion = function (appId) {
        return this.API.patch("/apps/".concat(appId, "/version"));
    };
    AppService.prototype.clearAppData = function (appId, dataType) {
        var url = "/apps/".concat(appId, "/clear/").concat(dataType);
        return this.API.delete(url);
    };
    AppService.prototype.getAppData = function (appId) {
        var url = "/apps/".concat(appId, "/clear");
        return this.API.get(url);
    };
    AppService.prototype.checkDelete = function (appId) {
        var url = "/apps/".concat(appId, "/deletecheck");
        return this.API.get(url);
    };
    AppService.prototype.getAppPublishConfig = function (appId, platform) {
        var url = "/apps/".concat(appId, "/publish-config/").concat(platform);
        return this.API.get(url);
    };
    AppService.prototype.upsertAppPublishConfig = function (appId, platform, config) {
        var url = "/apps/".concat(appId, "/publish-config/").concat(platform);
        return this.API.put(url, config);
    };
    AppService.prototype.clearAppPublishConfig = function (appId, platform) {
        var url = "/apps/".concat(appId, "/publish-config/").concat(platform);
        return this.API.delete(url);
    };
    AppService.prototype.updateFavourite = function (orgId, appId, is_favourite) {
        var url = "/apps/".concat(appId, "/favourite");
        return this.API.patch(url, {
            orgId: orgId,
            is_favourite: is_favourite,
        });
    };
    AppService.prototype.getAppOptionsList = function (version) {
        var url = "/apps/list";
        if (version) {
            url += "?".concat(version);
        }
        return this.API.get(url);
    };
    return AppService;
}());
export { AppService };
